export default [
  { name: 'Program', prop: 'program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name' },
  { name: 'Timer Type', prop: 'timer_type_id', type: 'autocomplete', references: 'admin/timer_types', referenceProp: 'timer_type' }
]
